<template>
  <!-- tiny页探针在此上报 -->
  <div
    class="observe-module"
    style="display: none"
    v-html="'<!--tiny-->'"
  />
</template>

<script>
import 'intersection-observer';

import { singlePageClParams } from '../../common/js/util';

export default {
  data() {
    return {
      io: null,
    };
  },
  mounted() {
    this.obStatus();
  },
  methods: {
    obStatus() {
      const mDom = document.querySelectorAll('.module');
      const self = this;
      if (!this.io) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((item) => {
            if (item.isIntersecting) {
              // detail漏出数据埋点
              let cname = item.target.className;
              cname = cname.replace('module', '');
              if (cname.indexOf('-') > -1) {
                [, cname] = cname.split('-');
              }
              const clParams = singlePageClParams(`ms_${cname.trim()}`);
              self.$uigs.send(clParams);
              self.io.unobserve(item.target);
            }
          });
        });
      }
      for (const md of mDom) {
        this.io.observe(md);
      }
    },
  },
};
</script>
